import yan from './TeamContent/11.jpg';
import devin from './TeamContent/12.jpg';
import anne from './TeamContent/13.jpg';
import marie from './TeamContent/14.jpg';

export const data = [
  {
      id: 0,
      image: yan,
      name: "YAN GOLDEN",
      position: "CO-FOUNDER",
      inst: "https://www.instagram.com/",
      face: "https://www.facebook.com/"

  },

  {
      id: 1,
      image: devin,
      name: "DEVIN BREWER",
      position: "BARISTA",
      inst: "https://www.instagram.com/",
      face: "https://www.facebook.com/"
  },

  {
      id: 2,
      image: anne,
      name: "ANNE MARSH",
      position: "BARISTA",
      inst: "https://www.instagram.com/",
      face: "https://www.facebook.com/"

  },

  {
      id: 3,
      image: marie,
      name: "MARIE SCOTT",
      position: "BARISTA",
      inst: "https://www.instagram.com/",
      face: "https://www.facebook.com/"
  }
]